var _mask, _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1065,
    height: 1064,
    viewBox: "0 0 1065 1064",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5712_4805",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532 1062.06C238.184 1062.06 -8.23005e-05 824.757 -6.9505e-05 532.03C-5.67095e-05 239.302 238.184 2.00001 532 2.00002C825.815 2.00004 1064 239.302 1064 532.03C1064 824.757 825.815 1062.06 532 1062.06Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532 1062.06C238.184 1062.06 -8.23005e-05 824.757 -6.9505e-05 532.03C-5.67095e-05 239.302 238.184 2.00001 532 2.00002C825.815 2.00004 1064 239.302 1064 532.03C1064 824.757 825.815 1062.06 532 1062.06Z",
    fill: "url(#paint0_radial_5712_4805)",
    fillOpacity: 0.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M532 1058.06C240.38 1058.06 3.99992 822.534 3.99993 532.03L-4.00007 532.03C-4.00008 826.98 235.989 1066.06 532 1066.06L532 1058.06ZM3.99993 532.03C3.99994 241.525 240.38 6.00001 532 6.00002L532 -1.99998C235.989 -1.99999 -4.00006 237.079 -4.00007 532.03L3.99993 532.03ZM532 6.00002C823.62 6.00004 1060 241.525 1060 532.03L1068 532.03C1068 237.079 828.011 -1.99996 532 -1.99998L532 6.00002ZM1060 532.03C1060 822.534 823.62 1058.06 532 1058.06L532 1066.06C828.011 1066.06 1068 826.98 1068 532.03L1060 532.03Z",
    fill: "url(#paint1_linear_5712_4805)",
    mask: "url(#path-1-inside-1_5712_4805)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 532.298,
    cy: 532.298,
    r: 470.398,
    stroke: "url(#paint2_radial_5712_4805)",
    strokeWidth: 14,
    strokeDasharray: "5 5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.298,
    cy: 532.298,
    r: 457.398,
    stroke: "url(#paint3_radial_5712_4805)",
    strokeWidth: 40,
    strokeDasharray: "6 32"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 532,
    r: 527.5,
    stroke: "url(#paint4_radial_5712_4805)",
    strokeWidth: 9,
    strokeDasharray: "6 32"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.299,
    cy: 532.298,
    r: 123.027,
    stroke: "url(#paint5_radial_5712_4805)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416.856 650.335C416.856 652.426 415.337 653.825 413.814 653.825C412.291 653.825 410.772 652.426 410.772 650.335C410.772 648.244 412.291 646.845 413.814 646.845C415.337 646.845 416.856 648.244 416.856 650.335Z",
    fill: "url(#paint6_radial_5712_4805)",
    stroke: "url(#paint7_radial_5712_4805)",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M653.826 650.335C653.826 652.426 652.307 653.825 650.784 653.825C649.261 653.825 647.742 652.426 647.742 650.335C647.742 648.244 649.261 646.845 650.784 646.845C652.307 646.845 653.826 648.244 653.826 650.335Z",
    fill: "url(#paint8_radial_5712_4805)",
    stroke: "url(#paint9_radial_5712_4805)",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M416.856 414.262C416.856 416.353 415.337 417.752 413.814 417.752C412.291 417.752 410.772 416.353 410.772 414.262C410.772 412.17 412.291 410.771 413.814 410.771C415.337 410.771 416.856 412.17 416.856 414.262Z",
    fill: "url(#paint10_radial_5712_4805)",
    stroke: "url(#paint11_radial_5712_4805)",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M653.826 414.262C653.826 416.353 652.307 417.752 650.784 417.752C649.261 417.752 647.742 416.353 647.742 414.262C647.742 412.17 649.261 410.771 650.784 410.771C652.307 410.771 653.826 412.17 653.826 414.262Z",
    fill: "url(#paint12_radial_5712_4805)",
    stroke: "url(#paint13_radial_5712_4805)",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5712_4805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.013 1061C824.171 1061 1061.01 824.159 1061.01 532C1061.01 239.841 824.171 3 532.013 3C239.854 3 3.0127 239.841 3.0127 532C3.0127 824.159 239.854 1061 532.013 1061Z",
    stroke: "url(#paint14_radial_5712_4805)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.013 915.705C741.605 915.705 911.513 745.797 911.513 536.205C911.513 326.613 741.605 156.705 532.013 156.705C322.421 156.705 152.513 326.613 152.513 536.205C152.513 745.797 322.421 915.705 532.013 915.705Z",
    stroke: "url(#paint15_radial_5712_4805)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.013 1061C824.171 1061 1061.01 824.159 1061.01 532C1061.01 239.841 824.171 3 532.013 3C239.854 3 3.0127 239.841 3.0127 532C3.0127 824.159 239.854 1061 532.013 1061Z",
    stroke: "url(#paint16_radial_5712_4805)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.013 915.705C741.605 915.705 911.513 745.797 911.513 536.205C911.513 326.613 741.605 156.705 532.013 156.705C322.421 156.705 152.513 326.613 152.513 536.205C152.513 745.797 322.421 915.705 532.013 915.705Z",
    stroke: "url(#paint17_radial_5712_4805)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532 532.03) rotate(90) scale(546.747 578.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479298,
    stopColor: "#545AE9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5712_4805",
    x1: 531.099,
    y1: 1047.31,
    x2: 531.099,
    y2: 2.00002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273861,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447081,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541673,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.782 566.399) rotate(90) scale(778.912 11740.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.782 566.399) rotate(90) scale(778.912 11740.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.653 570.001) rotate(90) scale(868 13083.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532.683 541.122) rotate(90) scale(201.543 3037.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.83 650.727) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.83 650.727) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.8 650.727) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.8 650.727) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.83 414.654) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.83 414.654) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.8 414.654) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.8 414.654) rotate(90) scale(8.95748 123.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.666 570.001) rotate(90) scale(868 13083.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.193 563.349) rotate(90) scale(620 9345.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.666 570.001) rotate(90) scale(868 13083.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_5712_4805",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(533.193 563.349) rotate(90) scale(620 9345.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4959EC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172108,
    stopColor: "#545AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495676,
    stopColor: "#C161C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812641,
    stopColor: "#4959EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4959EC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5712_4805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1065,
    height: 1064,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.9b0570984b4674132c3fbc7ad664ba49.svg";
export { ForwardRef as ReactComponent };